const GA_MEASUREMENT_ID = 'G-RZ5M7L52FH';
const META_PIXEL_ID = '1236393938572379';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
    fbq?: (...args: unknown[]) => void;
    _fbq?: (...args: unknown[]) => void;
  }
}

let initialized = false;

export function initAnalytics(): void {
  if (!import.meta.env.PROD) return;
  if (initialized) return;
  initialized = true;

  initGoogleAnalytics();
  initMetaPixel();
}

function initGoogleAnalytics(): void {
  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  // Snippet oficial GA4: pushea `arguments` (no array). gtag.js procesa la
  // queue distinguiendo Arguments objects de objects/arrays — arrays planos
  // se ignoran y el config call nunca configura la propiedad.
  const gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer!.push(arguments);
  } as (...args: unknown[]) => void;
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID);
}

function initMetaPixel(): void {
  if (window.fbq) return;

  // Snippet oficial de Meta Pixel adaptado a TS: define el dispatcher con queue
  // antes de que cargue fbevents.js para no perder llamadas tempranas.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const fbq: any = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
    } else {
      fbq.queue.push(args);
    }
  };
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [];

  window.fbq = fbq;
  if (!window._fbq) window._fbq = fbq;

  const script = document.createElement('script');
  script.async = true;
  script.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(script);

  fbq('init', META_PIXEL_ID);
  fbq('track', 'PageView');
}

export function trackSignUp(): void {
  if (!import.meta.env.PROD) return;
  window.gtag?.('event', 'sign_up', { method: 'email' });
  window.fbq?.('track', 'CompleteRegistration');
}

export function trackEmailVerified(): void {
  if (!import.meta.env.PROD) return;
  window.gtag?.('event', 'email_verified', { method: 'email' });
  window.fbq?.('trackCustom', 'EmailVerified');
}
